import React from "react";
import "../../Components/NewComponents/CartsSelector.css";
import { useTranslation } from "react-i18next";
import { deleteCurrentAvoir } from "../../REDUX/actions/avoir";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const AvoirHeader = ({ list, select, selected }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const handleSelect = (item) => {
    select(item);

    navigate(location.pathname, {
      state: { id: item?.id },
      replace: true,
    });
  };

  return (
    <div className="d-flex  mb-3 gap-2 cartSelectorContainer alignH ">
      {list?.map((item) => (
        <div
          onClick={() => handleSelect(item)}
          key={item}
          className={`position-relative alignH gap-4 mx-2 bold cartSelectorItem pointer p-3 ${
            selected?.id === item?.id ? "cartSelected" : "cartUnSelected"
          }`}
        >
          <div>
            <div className="f10">
              {item?.attributes?.edit ? t("Modification") : t("Creation")}
            </div>
            {t("Credit")} #{item?.attributes?.number}
          </div>

          <div
            className="deleteCart alignC t02"
            onClick={(e) => {
              e.stopPropagation();
              dispatch(
                deleteCurrentAvoir(item?.id, item?.attributes?.state, t)
              );
            }}
          >
            <i class="bi bi-x-lg text-lameRed pointer f12"></i>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AvoirHeader;
